import lazyScreen from '../utils/lazyScreen';
const CRMComsRule = lazyScreen(() => import('../pages/coms/CRMComsRule/index.js'), 'pages/coms/CRMComsRule/index.js');
const CRMComsInits = lazyScreen(() => import('../pages/coms/CRMComsInits/index.js'), 'pages/coms/CRMComsInits/index.js');
const CRMComsPayments = lazyScreen(() => import('../pages/coms/CRMComsPayments/index.js'), 'pages/coms/CRMComsPayments/index.js');

export default [
    {
        path: '/coms/CRMComsRule/:code',
        component: CRMComsRule
    },
    {
        path: '/coms/CRMComsInits',
        component: CRMComsInits
    },
    {
        path: '/coms/CRMComsPayments',
        component: CRMComsPayments
    }
];
